import { Box, Button } from "@mui/material";
import DateRangeField from "components/ui/dateRangeField";
import MultiSelect from "components/ui/multiSelect";
import { useFormik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import { ticketStatus } from "../table/MainTableRow";

const getInitialvalues = (filters) => {
  return {
    status: filters.status || [],
    user_id: filters.user_id || [],
    customer_id: filters.customer_id || [],
    project_id: filters.project_id || [],
    created_at_from: filters.created_at_from || null,
    created_at_to: filters.created_at_to || null,
  };
};
const MainScreenFilter = ({
  setReload,
  setFilters,
  setPagination,
  pagination,
  filters,
  projects,
  isFiltering,
  customers,
  assignees,
}) => {
  const [reset, setReset] = useState(false);
  const initialValues = getInitialvalues(filters);

  const validationSchema = yup.object({});
  const onSubmit = async (data) => {
    setFilters({ ...filters, ...data });
    setPagination({ ...pagination, current_page: 1 });
    setReload((pre) => !pre);
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
    enableReinitialize: true,
  });

  const resetForm = () => {
    const emptyFilter = {};
    for (const key in filters) {
      if (Array.isArray(filters[key])) {
        emptyFilter[key] = [];
      } else {
        emptyFilter[key] = null;
      }
    }
    formik.setValues(emptyFilter);
    setFilters({});
    setReload((pre) => !pre);
    setReset((pre) => !pre);
  };

  return (
    <Box
      p="15px 20px 5px"
      sx={{
        borderTop: "1px solid #efefef",
        bgcolor: "#fff",
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr",
        gap: "18px",
      }}
    >
     <MultiSelect
        options={ticketStatus}
        label="Statuses"
        value={formik?.values?.status}
        onChange={(value) => formik.setFieldValue("status", value)}
        selectProps={{
          id: "id",
          label: "label",
        }}
      />
      <MultiSelect
        options={customers}
        label="Customers"
        value={formik?.values?.customer_id}
        onChange={(value) => formik.setFieldValue("customer_id", value)}
        selectProps={{
          id: "id",
          label: "name",
        }}
      />
      <MultiSelect
        options={assignees}
        label="Assignees"
        value={formik?.values?.user_id}
        onChange={(value) => formik.setFieldValue("user_id", value)}
        selectProps={{
          id: "user_id",
          label: "name",
        }}
      />
      <MultiSelect
        options={projects}
        label="Projects"
        value={formik?.values?.project_id}
        onChange={(value) => formik.setFieldValue("project_id", value)}
        selectProps={{
          id: "id",
          label: "name",
        }}
      />
      <DateRangeField
        label="Created Date"
        from="created_at_from"
        to="created_at_to"
        formik={formik}
        key={`${reset}`}
      />
      <Box
        sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}
      >
        <Button
          variant="solid"
          onClick={formik.submitForm}
          disabled={!formik.dirty}
        >
          Filter
        </Button>
        <Button
          variant="outlined"
          onClick={resetForm}
          disabled={!isFiltering()}
        >
          Reset Filter
        </Button>
      </Box>
    </Box>
  );
};

export default MainScreenFilter;
